import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.set-prototype-of";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import * as React from 'react';
import { Box } from '../../../../../../layout/Box';
import { Dropdown } from '../../../../../../inputs/Dropdown';
import { Icon, IconSearch } from '../../../../../../imagesAndIcons/Icon';
import { LoadingSpinner } from '../../../../../../indicators/LoadingSpinner';
import { Text } from '../../../../../../typography/Text';
import styled from 'styled-components';
var SEARCH_INPUT_UNITS = 26;

var SearchHandle = function SearchHandle(_a) {
  var label = _a.label,
      placeholder = _a.placeholder,
      onBlur = _a.onBlur,
      onChange = _a.onChange,
      onClick = _a.onClick,
      inputRef = _a.inputRef,
      isLoading = _a.isLoading,
      isOpen = _a.isOpen;
  return React.createElement(Box, {
    alignItems: Box.AlignItems.Center,
    display: Box.Display.Flex
  }, isLoading ? React.createElement(LoadingSpinner, {
    size: LoadingSpinner.Size.Xs
  }) : React.createElement(IconSearch, {
    onClick: onClick,
    size: isOpen ? Icon.Size.Xs : Icon.Size.Sm,
    stroke: Icon.Stroke.Gray2
  }), React.createElement(SearchInput, {
    "aria-label": label,
    autoComplete: "off",
    isOpen: isOpen,
    name: "q",
    onBlur: onBlur,
    onChange: onChange,
    placeholder: placeholder,
    ref: inputRef,
    type: "search"
  }));
};

var Search =
/** @class */
function (_super) {
  __extends(Search, _super);

  function Search() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      isOpen: Boolean(_this.props.autoExpandInput)
    };
    _this.input = React.createRef();

    _this.focusOnInput = function (e) {
      e.preventDefault();

      if (_this.input.current) {
        var onFocus = _this.props.onFocus;

        _this.input.current.focus();

        if (onFocus) {
          onFocus(e);
        }

        _this.setState({
          isOpen: true
        });
      }
    };

    return _this;
  }

  Search.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        autoExpandInput = _a.autoExpandInput,
        emptyState = _a.emptyState,
        formUrl = _a.formUrl,
        isLoading = _a.isLoading,
        items = _a.items,
        itemRenderer = _a.itemRenderer,
        label = _a.label,
        onBlur = _a.onBlur,
        onChange = _a.onChange,
        _onClose = _a.onClose,
        onSelectItem = _a.onSelectItem,
        placeholder = _a.placeholder,
        resultsAreOpen = _a.resultsAreOpen;
    var isOpen = this.state.isOpen;
    return React.createElement(SearchForm, {
      action: formUrl,
      method: "GET",
      role: "search"
    }, React.createElement(SearchInputWrapper, {
      isOpen: isOpen
    }, React.createElement(Dropdown, {
      ariaLabel: label,
      dropdownHandle: {
        component: SearchHandle,
        props: {
          inputRef: this.input,
          isLoading: isLoading,
          isOpen: isOpen,
          onBlur: onBlur,
          onChange: onChange,
          onClick: this.focusOnInput,
          label: label,
          placeholder: placeholder
        }
      },
      hideCaret: true,
      isDivDropdown: true,
      isOpen: resultsAreOpen,
      onClose: function onClose(e) {
        if (!autoExpandInput) {
          _this.setState({
            isOpen: false
          });
        }

        if (_onClose) {
          _onClose(e);
        }
      },
      rightAlign: true,
      width: SEARCH_INPUT_UNITS
    }, React.createElement(Dropdown.List, {
      emptyState: emptyState,
      itemRenderer: itemRenderer,
      items: items,
      onSelectItem: onSelectItem
    }))));
  };

  Search.defaultProps = {
    items: []
  };
  return Search;
}(React.Component);

export { Search };
var SearchForm = styled.form(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: relative;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n"], ["\n    position: relative;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n"])));
var SearchInputWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background-color: ", ";\n    border-radius: ", ";\n    cursor: default;\n    padding: ", ";\n    position: absolute;\n    right: 0;\n    z-index: ", ";\n"], ["\n    background-color: ", ";\n    border-radius: ", ";\n    cursor: default;\n    padding: ", ";\n    position: absolute;\n    right: 0;\n    z-index: ", ";\n"])), function (props) {
  return props.isOpen ? props.theme.colors.gray5 : props.theme.colors.transparent;
}, function (props) {
  return props.theme.cornerRadii.circle;
}, function (props) {
  return props.theme.units.getValues([1, 1.5]);
}, function (props) {
  return props.theme.zIndex.Z_INDEX_10;
});
var SearchInput = styled.input(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    background-color: ", ";\n    border: 0;\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: 1rem;\n    padding-left: ", ";\n    text-overflow: ellipsis;\n    transition: ", ";\n    width: ", ";\n    z-index: ", ";\n\n    &:focus {\n        outline: none;\n    }\n\n    &::placeholder {\n        color: ", ";\n    }\n"], ["\n    background-color: ", ";\n    border: 0;\n    font-size: ", ";\n    font-weight: ", ";\n    line-height: 1rem;\n    padding-left: ", ";\n    text-overflow: ellipsis;\n    transition: ", ";\n    width: ", ";\n    z-index: ", ";\n\n    &:focus {\n        outline: none;\n    }\n\n    &::placeholder {\n        color: ", ";\n    }\n"])), function (props) {
  return props.isOpen ? props.theme.colors.gray5 : props.theme.colors.transparent;
}, function (props) {
  return props.theme.text.getSize(0);
}, function (props) {
  return props.theme.text.getWeight(Text.Weight.Medium);
}, function (props) {
  return props.isOpen ? props.theme.units.getValue(1.5) : 0;
}, function (props) {
  return props.theme.transitions["default"];
}, function (props) {
  return props.isOpen ? props.theme.units.getValue(SEARCH_INPUT_UNITS) : 0;
}, function (props) {
  return props.theme.zIndex.Z_INDEX_9;
}, function (props) {
  return props.theme.colors.gray2;
});
var templateObject_1, templateObject_2, templateObject_3;